import { useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { getCompanySettings } from './services/api';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ComponentsPage from './pages/ComponentsPage';
import ProductsPage from './pages/ProductsPage';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';
import BlogPage from './pages/BlogPage';
import BlogDetailPage from './pages/BlogDetailPage';
import PartsPage from './pages/PartsPage';
import CareersPage from './pages/CareersPage';
import ComponentDetailPage from './pages/ComponentDetailPage';
import ServiceDetailPage from './pages/ServiceDetailPage';

function App() {
  useEffect(() => {
    getCompanySettings().then(data => {
      if (data && data.favicon) {
        const link = document.querySelector("link[rel~='icon']") || document.createElement('link');
        link.rel = 'icon';
        link.href = data.favicon;
        document.head.appendChild(link);
      }
    });
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/components" element={<ComponentsPage />} />
        <Route path="/components/:slug" element={<ComponentDetailPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/services/:slug" element={<ServiceDetailPage />} />
        <Route path="/parts" element={<PartsPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogDetailPage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
    </Router>
  );
}

export default App;
